import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { fmtUSD, fmtNum } from "../lib/format";
import { PageHeader, StatusBadge } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { Loader } from "../components/KpiCard";
import { Modal, Field, TextInput, SelectInput, AddButton } from "../components/Form";

const PTYPES = ["Direct Service", "Advocacy", "Education", "Research"];

export default function Programs() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ program_name: "", program_type: "Direct Service", director: "", target_population: "", participants_served: 0 });

  const load = () => api.get("/programs").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/programs", { ...form, participants_served: Number(form.participants_served || 0) });
      toast.success("Program added");
      setOpen(false);
      setForm({ program_name: "", program_type: "Direct Service", director: "", target_population: "", participants_served: 0 });
      load();
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  if (!rows) return <Loader />;

  const columns = [
    { key: "program_name", label: "Program", className: "font-medium" },
    { key: "program_type", label: "Type", render: (r) => <StatusBadge tone="blue">{r.program_type}</StatusBadge> },
    { key: "director", label: "Director", className: "text-[#5C5C54]" },
    { key: "target_population", label: "Population", className: "text-[#5C5C54]" },
    { key: "participants_served", label: "Served", align: "right", render: (r) => fmtNum(r.participants_served) },
    { key: "total_cost", label: "Total Cost", align: "right", render: (r) => fmtUSD(r.total_cost) },
    { key: "cost_per_participant", label: "Cost / Participant", align: "right", render: (r) => fmtUSD(r.cost_per_participant) },
  ];

  return (
    <div>
      <PageHeader title="Program Management" subtitle="Connect mission activities to financial data and measure impact."
        action={<AddButton onClick={() => setOpen(true)} label="New Program" testid="add-program-btn" />} />
      <DataTable columns={columns} rows={rows} testid="programs-table" />

      <Modal open={open} onOpenChange={setOpen} title="New Program" onSubmit={submit} busy={busy} testid="program-modal">
        <Field label="Program Name" span={2}><TextInput required value={form.program_name} onChange={(e) => setForm({ ...form, program_name: e.target.value })} /></Field>
        <Field label="Type"><SelectInput value={form.program_type} onChange={(e) => setForm({ ...form, program_type: e.target.value })} options={PTYPES} /></Field>
        <Field label="Participants Served"><TextInput type="number" value={form.participants_served} onChange={(e) => setForm({ ...form, participants_served: e.target.value })} /></Field>
        <Field label="Director"><TextInput value={form.director} onChange={(e) => setForm({ ...form, director: e.target.value })} /></Field>
        <Field label="Target Population"><TextInput value={form.target_population} onChange={(e) => setForm({ ...form, target_population: e.target.value })} /></Field>
      </Modal>
    </div>
  );
}
